<template>
	<section class="section ht-profile-page">
		<Loading :active.sync="loading"></Loading>
		<div class="columns is-centered">
			<div class="column is-6 is-5-fullhd">
				<Cmspos position="profile"></Cmspos>

				<h1 class="title">{{ $t('User profile') }}</h1>
				<p>
					<label class="label">{{ $t('Name') }}</label>
					{{ user.lastname }} {{ user.firstname }}
				</p>
				<b-field :label="$t('Bidder name')" :disabled="disabled">
					<b-input v-model="preferences.name" :disabled="disabled" :placeholder="preferences.name"></b-input>
				</b-field>
				<b-field grouped>
					<b-field :label="$t('Language')" :disabled="disabled" expanded>
						<b-select v-model="preferences.language" :placeholder="$t('Language')" expanded :disabled="disabled">
							<option value="HU">{{ $t('Hungarian') }}</option>
							<option value="EN">{{ $t('English') }}</option>
						</b-select>
					</b-field>
					<b-field :label="$t('Currency')" :disabled="disabled" expanded>
						<b-select v-model="preferences.currency" :placeholder="$t('Currency')" expanded :disabled="disabled">
							<option value="HUF">HUF</option>
							<option value="EUR">EUR</option>
							<option value="USD">USD</option>
						</b-select>
					</b-field>
				</b-field>
				<div class="block">
					<p class="control">
						<b-checkbox v-model="preferences.bid_placed_mail" :disabled="disabled" expanded>{{
							$t('user_page.bid_placed_mail')
						}}</b-checkbox>
					</p>

					<p class="control">
						<b-checkbox v-model="preferences.overbidden_mail" :disabled="disabled" expanded>{{
							$t('user_page.overbidden_mail')
						}}</b-checkbox>
					</p>
				</div>
				<b-button class="is-primary" outlined @click="editUser()">{{ profileBtnText }}</b-button>
			</div>
		</div>
	</section>
</template>
<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import Cmspos from '@/components/common/Cmspos.vue'
// import UsersProducts from "@/components/frontend/profiles/UsersProducts.vue";
// import UserFavorites from "@/components/frontend/profiles/UserFavorites.vue";
//import ProductBid from "@/components/frontend/products/ProductBid.vue";
//import ProfileEdit from "@/components/frontend/profiles/ProfileEdit.vue";

export default {
	name: 'Profile',
	components: {
		Loading,
		Cmspos,
		//ProductBid,
		//ProfileEdit
		// UserBids,
		// UsersProducts,
		// UserFavorites
	},
	metaInfo () {
		return {
			title: this.$t("User profile"),
			meta: [
				{ name: 'robots', content: 'noindex' },
			]
		}
	},
	data() {
		return {
			loading: true,
			//productList: [],
			disabled: true,
			profileBtnText: this.$t('Edit profile'),
			user: {},
			preferences: {},
		}
	},
	methods: {
		getUser() {
			var _this = this
			setTimeout(function () {
				_this.$http.get('/users').then((response) => {
					console.log('Profile', response.data)
					_this.user = response.data.user
					_this.preferences = response.data.user.UserPreference
					console.log('___________ preferences:', _this.preferences)
					if (!_this.preferences.name) {
						_this.preferences.name = _this.user.bidder_name
					}
					if (!_this.preferences.currency) {
						_this.preferences.currency = 'HUF'
					}
					if (!_this.preferences.language) {
						_this.preferences.language = 'HU'
					}
					_this.preferences.bidder_name = _this.preferences.name
					_this.loading = false
				})
			}, 100)
		},
		editUser() {
			var _this = this
			_this.profileBtnText = _this.$t('Save')
			if (_this.disabled) {
				_this.disabled = false
				return
			}
			_this.$http
				.post('/userpref/update', _this.preferences)
				.then((response) => {
					if (response.data.success){
						_this.$buefy.snackbar.open({
							message: _this.$t('Profile saved'),
							position: 'is-top',
						})
						localStorage.setItem('lang', _this.preferences.language.toLowerCase())
						localStorage.setItem('currency', _this.preferences.currency)
						_this.$i18n.locale = _this.preferences.language.toLowerCase()
						_this.disabled = true
						_this.lang = localStorage.getItem('lang'),
						_this.$root.$emit('change_locale', _this.lang)
						_this.profileBtnText = _this.$t('Edit profile')
					//window.location.reload()
					} else {
						_this.$buefy.snackbar.open({
							type: 'is-danger',
							message: _this.$t('The bidder name is already in use, please choose another name.'),
							position: 'is-top',
						})
					}})
				.catch(function (error) {
					console.log(error)
					_this.$buefy.snackbar.open({
						message: _this.$t('Error'),
						type: 'is-danger',
						position: 'is-top',
						duration: 5000,
					})
				})
		},
	},
	mounted() {
		this.getUser()
	},
}
</script>

<style scoped>
.stat-val {
	font-size: 3em;
	padding-top: 20px;
	font-weight: bold;
}

.stat-key {
	font-size: 1.4em;
	font-weight: 200;
}

.section.profile-heading .column.is-2-tablet.has-text-centered + .has-text-centered {
	border-left: 1px dotted rgba(0, 0, 0, 0.2);
}

.control.is-pulled-left span.select {
	margin-right: 5px;
	border-radius: 2px;
}
</style>
